import { render } from "./BranchReport.vue?vue&type=template&id=f498149a&scoped=true"
import script from "./BranchReport.vue?vue&type=script&lang=js"
export * from "./BranchReport.vue?vue&type=script&lang=js"

import "./BranchReport.vue?vue&type=style&index=0&id=f498149a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f498149a"]])

export default __exports__